import { ToastUtility } from '@syncfusion/ej2-react-notifications';

export const ShowToast = (Title, Message, Type) => {
  return (
    ToastUtility.show({
      title: Title, content: Message, timeOut: 5000, position: { X: 'Right', Y: 'Bottom' }, showCloseButton: true, cssClass: Type
    })
  );
}
